<template>
  <div>
    <v-card class="px-1 elevation-0 rounded-0 borderless" :key="$_sideMenu">
      <v-card class="firms-sticky-bar d-flex flex-row elevation-6 mt-0 mx-0"
              tile block style="border-top: 1px solid white !important"
              v-sticky sticky-z-index="99" sticky-offset="$_offset">
          <!-- 15 Jul 2026 JCH: NC-1616 — Jobs/Retries/Ticklers segments replace the View Jobs button
               (same "Show" pattern as the email page). Selected segment = the list you're in, and it
               stays lit while a firm opened from that list is on screen (re-click restores the list —
               the old button's "way back" role). Nothing lit = firms work. -->
          <div class="firms-sticky-toggle d-flex align-center flex-shrink-0">
            <span v-if="$vuetify.breakpoint.name !== 'xs'"
                  class="jobs-toggle-view-label grey--text text--darken-3 mr-2">View</span>
            <v-btn-toggle
              class="jobs-retries-toggle"
              dense
              :key="jobsToggleRefresh"
              :value="jobsToggleValue"
              @change="onJobsRetriesToggle"
            >
              <v-btn value="jobs" small text title="View the jobs list">Jobs</v-btn>
              <v-btn value="retries" small text title="View the retries list">Retries</v-btn>
              <v-btn value="ticklers" small text title="View your ticklers (future jobs)">Ticklers</v-btn>
            </v-btn-toggle>
          </div>

          <v-dialog style="background-color: white; z-index: 999" v-model="selectUsers" max-width="500"
                    content-class="jobs-users-dialog">
            <v-card>
              <v-card-actions class="pt-4 pr-3 jobs-users-dialog-actions">
                <div class="jobs-users-dialog-title">Users' active/extreme jobs (job counts)</div>
                <v-spacer/>
                <v-btn @click="viewJobs(false, names, jobsListMode === 'retries' ? 'retries' : 'jobs')"
                       color="secondary" :disabled="names.length === 0"
                       class="jobs-users-dialog-show"
                       :small="$vuetify.breakpoint.name === 'xs'">
                  Show {{ jobsListMode === 'retries' ? 'Retries' : 'Jobs' }}
                </v-btn>
                <v-btn color="secondary darken-3" icon class="jobs-users-dialog-close"
                       @click="selectUsers = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
              <br><br>
              <v-card-text class="pl-5 pr-12">
                <smart-input
                  chips
                  clearable
                  :clear-value="[]"
                  dense
                  deletable-chips
                  :item-text="item =>`${item.staff} ${item.activejobs}/${item.extremejobs}`"
                  :item-value="'staff'"
                  :items="userJobCounts"
                  label="Select users to show jobs for:"
                  :menu-props="userSelectMenuProps"
                  multiple
                  :no-data-text="userJobCountsLoading || !userJobCountsLoaded
                    ? 'Loading users…' : 'No other users with job counts'"
                  small-chips
                  :type="'VAutocomplete'"
                  v-model="names"
                  @focus="updateUserSelectMenuMaxHeight"/>
              </v-card-text>
              <br>
            </v-card>
          </v-dialog>

          <v-dialog style="background-color: white; z-index: 999" v-model="showCheckOptions" max-width="500">
            <v-card>
              <v-card-actions class="pt-4 pr-3">Status
                <v-spacer/>
                <v-btn @click="jobsSelectedUpdate()" color="secondary" :disabled="!statusForCheckedJobs"
                       v-if="jobsSelected.length">Update Checked</v-btn>
                <v-btn color="secondary darken-3" icon @click="showCheckOptions = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
              <br>
              <!-- 15 Jul 2026 JCH: NC-1616 — copy follows the list mode (jobs/retries/ticklers) -->
              <v-card-text class="ma-1 body-2 font-italic">
                <ul>
                  <li v-if="!jobsSelected.length">Select {{ modeWords.many }} to change status by checking the boxes</li>
                  <li v-if="jobsListMode !== 'ticklers'">{{ modeWords.Many }} must be in your name ('For' column) to change status</li>
                  <li v-if="jobsSelected.length">Setting status to done or cancel removes {{ modeWords.many }} from this list</li>
                </ul>
              </v-card-text>
              <v-card-text class="pl-12 ml-4" v-if="jobsSelected.length">
                <h2>{{jobsSelected.length}} {{ jobsSelected.length === 1 ? modeWords.one : modeWords.many }} selected</h2>
              </v-card-text>
              <v-card-text class="pl-5 pr-12" v-if="jobsSelected.length">
                <smart-input
                  :items="$_lists.nstatus"
                  :label="`Update checked ${modeWords.many} to status:`"
                  :type="'VAutocomplete'"
                  v-model="statusForCheckedJobs"/>
              </v-card-text><br>
            </v-card>
          </v-dialog>

        <div class="firm-fid-wrap" style="margin-top: -7px; margin-bottom: 3px">
          <v-text-field
              class="smalltext px-3"
                        @click="searchByFid = true, unisearch = ''"
                        clearable
                        dense
                        hide-details
                        @keyup.enter="searchFirms()"
                        label="Get by FID"
                        single-line
                        v-model="whereColumns.fid"
          ></v-text-field>
        </div>
        <div class="firms-sticky-actions d-flex align-center flex-shrink-0">
          <!-- 16 Jul 2026 JCH: NC-1616 — hide new-tab on xs; sticky bar is too tight for it -->
          <button-tip v-if="$vuetify.breakpoint.name !== 'xs'"
                      btnclass="pa-0 ma-n1" @click="firmSearchInTab()" icolor="black"
                      icon iname="mdi-arrow-top-right" tip="Show Search Options in New Tab"/>
          <button-tip btnclass="firms-sticky-fab ml-1 mr-1 ml-sm-6 mr-sm-4"
                      btnstyle="margin-top: -2px; transform: scale(.8)"
                      @click="$_editFirm(0)" color="secondary" elevation="5" fab icolor="white"
                      iname="mdi-plus" xsmall tip="Create Firm" v-if="$_can('firm-edit')"/>
          <button-tip btnclass="firms-sticky-firms px-xs-0 px-sm-12 py-0" small text tile
                      hideSmDown="Search " txt=" Firms" @click="searchFirmsButton()"
                      :tip="state === 'showFirms' || state === 'loadingFirms'
                       ? 'To see firms, enter a FID or unisearch (2-char min) then hit return'
                       : 'To see firms, enter a FID & press return or click SEARCH FIRMS, enter unisearch (2-char min) then hit return'"/>
        </div>
      </v-card>

      <firms-options
          :checkedProp="checkedColumns"
          @clear="clearOptions()"
          :info="info"
          @search="searchByFid = false, searchFirms()"
          @update="update"
          v-if="seeMoreOptions"
          :whereProp="whereColumns"
      ></firms-options>

      <v-expansion-panels readonly v-model="panels" multiple class="my-0 py-0 rounded-0" v-show="panels.length > 0">
        <v-expansion-panel class="px-0 elevation-24">
          <v-expansion-panel-header color="h5 secondary--text darken-3 font-weight-medium"
                                    class="dense pl-0 pr-4 py-0 my-n1 heading-2" disabled hide-actions id="plain">
            <v-spacer/>
            <v-row class="mt-n2 mb-n1 justify-space-between" v-if="state === 'loadingJobs'  || state === 'showJobs'">
              <button-tip btnclass="py-0 ml-n3 mt-n3 mb-0"  @click="refreshJobs()" icon iname="mdi-update"
                          :tip="`Refresh ${modeWords.Many}`"/>
              <!-- 16 Jul 2026 JCH: NC-1616 — FirmPoliciesTable wash; size/offset always so check doesn't jump -->
              <button-tip btnclass="ml-n2 mr-n1 mt-n3"
                          @click="showCheckOptions = true"
                          icon
                          :btnstyle="jobsSelected.length
                            ? 'background-color:rgba(76,95,60,.12);border-radius:50%;height:30px;min-width:30px;width:30px;transform:translate(6px,4px)'
                            : 'background-color:transparent;border-radius:50%;height:30px;min-width:30px;width:30px;transform:translate(6px,4px)'"
                          :icolor="jobsSelected.length ? 'black' : 'grey'"
                          iname="mdi-dots-vertical"
                          :istyle="jobsSelected.length
                            ? 'font-size:28px!important;font-weight:900;text-shadow:0 0 0 currentColor'
                            : 'font-size:28px!important'"
                          :tip="jobsSelected.length
                            ? `Change status for ${jobsSelected.length} checked ${modeWords.many}`
                            : `Check ${modeWords.many}, then change status`"/>
              <v-row class="ml-3 mt-0 align-center jobs-toolbar-cluster">
                <!-- 16 Jul 2026 JCH: NC-1616 — My-list icon for override on jobs/retries only; keep footprint
                     in ticklers (visibility:hidden) so count/usernames don't jump on mode switch -->
                <button-tip v-if="$_can('job-override')"
                            btnclass="py-0 ml-n2 mt-n3 mb-0"
                            :btnstyle="jobsListMode === 'ticklers'
                              ? 'visibility:hidden;pointer-events:none'
                              : ''"
                            @click="viewJobs(false, [username], jobsListMode)"
                            icon iname="mdi-account"
                            :tip="`My ${modeWords.Many}`"
                            :tooltip-disabled="jobsListMode === 'ticklers'"/>
                <span class="mr-2 jobs-toolbar-up5 jobs-count" :class="{ 'ml-5': $_can('job-override') }" :key="refreshJobCount">
                  {{ jobs.length > 0 ? jobs.length.toLocaleString('en', {useGrouping:true}) : ''}}</span>
                <!-- 16 Jul 2026 JCH: NC-1616 — keep username visible on xs (was hidden; only way to see whose list) -->
                <span class="jobs-toolbar-up5 jobs-usernames-wrap">
                  <v-tooltip bottom :key="refreshUsernames"
                             v-if="$_can('job-override') && jobsListMode !== 'ticklers'">
                    <template v-slot:activator="{ on }">
                      <div class="jobs-retries-usernames" style="color: black" v-on="on" @click="openSelectUsers">
                        {{ usernamesToShowJobsFor && usernamesToShowJobsFor.toString().length > spaceForUsernames
                          ? usernamesToShowJobsFor.toString().slice(0, spaceForUsernames-5).split(',').join(', ') + '...'
                          : ((usernamesToShowJobsFor && usernamesToShowJobsFor.toString().split(',').join(', ')) || '') }}
                      </div>
                    </template>
                    Click to select users to see {{ modeWords.many }} for
                  </v-tooltip>
                  <!-- 15 Jul 2026 JCH: NC-1616 — explain why the user picker is gone in ticklers mode -->
                  <v-tooltip bottom v-else-if="jobsListMode === 'ticklers'">
                    <template v-slot:activator="{ on }">
                      <div class="ticklers-own-user" style="color: black" v-on="on">
                        {{ (usernamesToShowJobsFor && usernamesToShowJobsFor.toString()) || '' }}
                      </div>
                    </template>
                    Ticklers (future jobs) show for your own username only
                  </v-tooltip>
                  <template v-else>
                    <v-tooltip bottom :key="refreshUsernames"
                               v-if="usernamesToShowJobsFor && usernamesToShowJobsFor.toString().length > spaceForUsernames">
                      <template v-slot:activator="{ on }">
                        <div class="caption" style="margin-top: -2px; color: black" v-on="on">
                          {{ usernamesToShowJobsFor.toString().slice(0, spaceForUsernames-5).split(',').join(', ') + '...' }}
                        </div>
                      </template>
                      {{ usernamesToShowJobsFor.toString().split(',').join(', ') || '' }}
                    </v-tooltip>
                    <!-- 15 Jul 2026 JCH: NC-1616 — non-override users can't pick users; say why the name isn't a control -->
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on }">
                        <div class="jobs-nonoverride-user" style="color: black" v-on="on">
                          {{ usernamesToShowJobsFor.toString().split(',').join(', ') || '' }}
                        </div>
                      </template>
                      {{ modeWords.Many }} shown for your username
                    </v-tooltip>
                  </template>
                </span>
              </v-row>
            </v-row>
            <span class="py-0 mt-n4 mb-n1 mx-0 firms-title-group" v-if="state === 'loadingFirms' || state === 'showFirms'">
              <button-tip btnclass="py-0 mt-n3 mb-n2 ml-n1 mr-0 firms-refresh-btn" icon iname="mdi-update" tip="Refresh Firms" @click="refreshFirms()"/>
              <span class="firms-title-text" v-if="firmsHeaderCount">{{ firmsHeaderCount }}</span>
              <button-tip btnclass="pa-0 ml-n1 mr-n2 mt-0" color="secondary" icon iname="mdi-filter-check" ismall stop
                          tip="Detailed filters active" v-if="hiddenDetailedSearchFiltersActive"
                          @click="seeMoreOptions = false, seeMoreOptionsBelow = true, panels = [0]"/>
              <span class="firms-title-text ml-1">Firms</span>
            </span>
            <information-dialog-icon confirmClass="mr-3 mb-1 title" confirmColor="secondary darken-1" icon-class="mt-n2"
              icon-style="max-width: 40px; margin: 4px 3vw"
              :title="`${modeWords.Many} Table Information`"
              tclass="headline grey lighten-2 mb-8 jobs-info-dialog-title"
              compact-body-on-xs
              v-if="state === 'loadingJobs' || state === 'showJobs'">
                <p>Use the <strong>Jobs</strong> / <strong>Retries</strong> / <strong>Ticklers</strong> toggle in the top bar to switch
                  lists. The segment stays highlighted while a firm from that list is open — click it again to return.
                  No highlight means you are viewing firms.</p>
                <p>Click<v-icon>mdi-dots-vertical</v-icon>to change status of selected {{ modeWords.many }}.</p>
                <p>This table shows your jobs and jobs for groups you are allowed for (ACLs). Retries use the
                  retries list (not ACLs). Ticklers are future-dated notes — each joins jobs when due —
                  and always show for your own username only.</p>
                <p v-if="$_can('job-override')">To see other users' jobs or retries, click the username next to the count,
                  select username(s), then SHOW (selected users only, not ACLs). Click<v-icon>mdi-account</v-icon>to return to your list.</p>
                <p v-if="$_can('job-override')">In the jobs dialog dropdown, active/extreme job counts appear next to the usernames.</p>
                <p>Drag column headers to reorder columns.</p>
            </information-dialog-icon>
            <v-menu allow-overflow :close-on-content-click="false" :open-on-click="false" v-model="seeMoreOptionsBelow" offset-y
                    nudge-top="9" nudge-width="200" style="max-height: 700px; width: calc(80vw + 200px)"
                    v-if="state === 'loadingFirms' || state === 'showFirms'">
              <template v-slot:activator="{ on }">
                <v-btn
                    class="text-none px-0"
                    v-on="on"
                    elevation="0"
                    style="background-color: white"
                >
                <v-text-field
                              append-icon="mdi-magnify" clearable dense style="width: 75vw; margin-right: 20px"
                              @click.prevent="whereColumns.fid = '', seeMoreOptions = false, seeMoreOptionsBelow = false"
                              v-model="unisearch"
                              hide-details single-line
                              @keyup.enter="unisearchFirms()"
                              label="Unisearch sort, name, phone, contact, insured"
                              class="pl-0 pr-2 mt-n12 mb-n7 mr-2 font-weight-regular firm-unisearch-field"
                >
                  <template v-slot:prepend>
                    <information-dialog-icon
                        confirmClass="ml-1 mr-2 mb-1 title" confirmColor="secondary darken-1" icon-class="mt-n1 ml-2 mr-n2"
                        title="Firms Search Options" tclass="headline grey lighten-2 mb-8 firms-search-info-title">
                      <p>Click <v-icon>mdi-arrow-down</v-icon> for options below.</p>
                      <p>Click <v-icon>mdi-close</v-icon>to close options.</p>
                      <p>Click <v-icon>mdi-arrow-up</v-icon> for options above.</p>
                      <p>Click <v-icon>mdi-arrow-top-right</v-icon> for options in a new tab.</p>
                      <p><v-icon small>mdi-filter-check</v-icon> Hidden filters. Unisearch max 100.</p>
                      Table columns will appear in the order checked.
                      To change the order, you can uncheck the boxes (except FID) and then check them
                      in the order you want. Fields with an arrow allow you to search in and select from
                      a list. Fields with no arrow allow you to enter full or partial data.
                      <br><br>
                      <b>Press ENTER in any field to SUBMIT firms search.</b>
                      <br><br>
                      <p><b>Click UNISEARCH field to CLOSE search options.</b></p>
                    </information-dialog-icon>
                  </template>
                  <template v-slot:prepend-inner>
                    <button-tip btnclass="pa-0 ma-n1" @click="seeMoreOptionsBelow = false" icolor="black"
                                icon iname="mdi-close" tip="Close Search Options Below" v-if="seeMoreOptionsBelow"/>
                    <button-tip btnclass="pa-0 ma-n1" @click="seeMoreOptionsBelow = true, seeMoreOptions = false" icolor="black"
                                icon iname="mdi-arrow-down" tip="Show Search Options Below" v-if="!seeMoreOptionsBelow"/>
                    <button-tip btnclass="pa-0 ma-n1" @click="seeMoreOptions = false" icolor="black"
                                icon iname="mdi-close" tip="Close Search Options Above" v-if="seeMoreOptions"/>
                    <button-tip btnclass="pa-0 ma-n1" @click="seeMoreOptions = true, seeMoreOptionsBelow = false" icolor="black"
                                icon iname="mdi-arrow-up" tip="Show Search Options Above" v-if="!seeMoreOptions"/>
                    <button-tip btnclass="pa-0 ma-n1" @click="firmSearchInTab()" icolor="black"
                                icon iname="mdi-arrow-top-right" tip="Show Search Options in New Tab"/>
                  </template>
                </v-text-field>
              </v-btn>

              </template>
                <firms-options
                    :checkedProp="checkedColumns"
                    @clear="clearOptions()"
                    :info="info"
                    @search="searchByFid = false, searchFirms()"
                    @update="update"
                    :whereProp="whereColumns"
                ></firms-options>
            </v-menu>

            <!-- sm+: full Search field (unchanged). xs only: short line + "search" caption -->
            <v-text-field v-if="(state === 'loadingJobs' || state === 'showJobs')
                            && $vuetify.breakpoint.name !== 'xs'"
                          v-model="search" @click.stop @keydown.enter.prevent
                          append-icon="mdi-magnify" clearable dense single-line
                          :label="`Search ${modeWords.Many}`" style="width: 30vw" hide-details
                          class="jobs-search-wrap mt-n12 mb-n7 ml-1 mr-1 font-weight-regular">
            </v-text-field>
            <div v-if="(state === 'loadingJobs' || state === 'showJobs')
                   && $vuetify.breakpoint.name === 'xs'"
                 class="jobs-search-wrap-xs"
                 :title="`Search ${modeWords.Many}`">
              <v-text-field
                v-model="search"
                @click.stop
                @keydown.enter.prevent
                append-icon="mdi-magnify"
                placeholder=" "
                dense
                single-line
                hide-details
                class="jobs-search-field-xs font-weight-regular">
              </v-text-field>
              <span class="jobs-search-caption">search</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="noPadding">
            <v-data-table checkbox-color="secondary darken-1"
                          class="jobsTable elevation-2 mt-n3 mb-2 pb-0"
                          :dense="dense"
                          fixed-header
                          :headers="headers"
                          hide-default-footer
                          :item-class="jobRowClass"
                          item-key="nid"
                          :items="jobs"
                          :items-per-page="-1"
                          :loading="state === 'loadingJobs'"
                          :key="anIncreasingNumber"
                          :loading-text="`Loading ${modeWords.many}... Please wait`"
                          multi-sort
                          :no-data-text="`No ${modeWords.many} to show`"
                          :mobile-breakpoint="0"
                          :search="search"
                          :selectable-key="'selectable'"
                          :show-select="true"
                          :sort-by="['staff', 'status', '_lag', 'cstamp']"
                          :sort-desc="[false, true, false, false]"
                          :style="$_cssVars"
                          v-if="state === 'loadingJobs' || state === 'showJobs'"
                          v-model="jobsSelected"
                          v-sortable-table="{onEnd:sortTheHeadersAndUpdateTheKey}">
              <template v-slot:item.actions="{ item }">
                <v-lazy>
                  <div>
                    <button-tip @click="openJobFirmInPopup(item)" icon iname="mdi-open-in-new" small tip="Open Popup"/>
                    <button-tip @click="openJobFirmBelow(item)" icon iname="mdi-eye-outline" small tip="Open Below"/>
                  </div>
                </v-lazy>
              </template>
              <template v-slot:item.firm_sort="{ item }">
                <!-- 16 Jul 2026 JCH: controlled tooltip (LedgersSearch pattern) — default v-tooltip
                     sticks when search/sort/refresh replaces the activator mid-hover -->
                <v-tooltip left v-if="item.firm_sort && item.firm_sort.length > 30"
                           :open-on-hover="false" :open-on-focus="false" close-delay="0"
                           :value="activeFirmSortTooltipNid === item.nid">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="firmSortTooltipOn(on, item)">
                      {{ item.firm_sort ? item.firm_sort.slice(0, 25) + '...' : '' }}
                    </div>
                  </template>
                  {{ item.firm_sort || '' }}
                </v-tooltip>
                <div v-else>{{ item.firm_sort || '' }}</div>
              </template>
              <template v-slot:item.status="{ item }">
                <div :style="{color: (item.status === 'xtreme' ? 'red'
                  : (item.status === 'urgent' ? 'blue' : 'black'))}">
                  {{ item.status }}
                </div>
              </template>
              <template v-slot:item._lag="{ item }">
                <div :style="{color: (item.status === 'xtreme' ? 'red'
                  : (item.status === 'urgent' ? 'blue' : 'black'))}">
                  {{ item._lag }}
                </div>
              </template>
              <template v-slot:item.re="{ item }">
                <div v-html="item.re"></div>
              </template>
              <template v-slot:item.cstamp="{ item }">
                {{ moment(item.cstamp, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD MMM YYYY hh:mm A ddd')}}
              </template>
            </v-data-table>
            <view-firms-table ref="viewFirmsTable"
                              :firms="firms"
                              :checked-columns="checkedColumns"
                              :dense="dense" :total-records="totalRecords"
                              :can-bypass-firm-list-limit="canBypassFirmListLimit"
                              :is-unisearch="isUnisearch"
                              :edit-firm-rights="$_can('firm-edit')"
                              :state="state"
                              :loading-text="firmsLoadingText"
                              :styleProp="$_cssVars"
                              :highlighted-fid="highlightedFirmFid"
                              @pop-up="firmPopup"
                              @view-firm="seeMoreOptions = false, notPopup = true, viewFirmSearch(...arguments)"
                              @search="searchFirmsNow"></view-firms-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

    </v-card>

    <v-snackbar app color="error" v-model="overFirmLimit" style="top: 80px;" top>
      Reached 100 firm limit! Please narrow your search.
      <v-btn color="white" @click="overFirmLimit = false" text>Close</v-btn>
    </v-snackbar>

    <v-snackbar app color="error" v-model="noResults" style="top: 80px;" top>
      {{ firmsNoResultsText }}
      <v-btn color="white" @click="noResults = false" text>Close</v-btn>
    </v-snackbar>

    <v-snackbar app color="error" v-model="emptyFields" style="top: 80px;" top>
      At least one search field must be filled to run a search.
      <v-btn color="white" @click="emptyFields = false" text>Close</v-btn>
    </v-snackbar>

    <ErrorDialog ref="errorDialog"/>
    <view-firm  v-if="showFirmTabs"
                :noNote="noNote"
                :showFirm="showFirm"
                notPopup
                :id="id"
    />
  </div>
</template>

<script>
  // Add back the sortHandle class if it gets stripped away by external code
  function watchClass(targetNode, classToWatch) {
    // watchClass(targetNode, classToWatch) {
    let lastClassState = targetNode.classList.contains(classToWatch);
    const observer = new MutationObserver((mutationsList) => {
      for (let i = 0; i < mutationsList.length; i++) {
        const mutation = mutationsList[i];
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const currentClassState = mutation.target.classList.contains(classToWatch);
          if (lastClassState !== currentClassState) {
            lastClassState = currentClassState;
            if (!currentClassState) {
              mutation.target.classList.add('sortHandle');
            }
          }
        }
      }
    });
    observer.observe(targetNode, { attributes: true });
  }

  import ErrorDialog from "../../ErrorDialog";
  import FirmsOptions from "./FirmsOptions";
  import InformationDialogIcon from "../../InformationDialogIcon";
  import ListViewer from "../../ListViewer";
  import Sortable from 'sortablejs';
  import ViewFirm from "@/components/search/firms/ViewFirm";
  import ViewFirmsTable from "./firmsSearch/ViewFirmsTable";
  import { CommonAPIService } from '@/servicehandlers/CommonHandler';
  import { FirmsAPIService } from '@/servicehandlers/FirmsAPIService';
  import { GroupsAPIService } from '@/servicehandlers/GroupsAPIService';
  import { NotesAPIService } from '@/servicehandlers/NotesAPIService';
  import { UsersAPIService } from '@/servicehandlers/UsersAPIService';

  const apiService = new CommonAPIService();
  const firmAPIService = new FirmsAPIService();
  const groupsAPIService = new GroupsAPIService();
  const note = new NotesAPIService();
  const usersAPIService = new UsersAPIService();

  export default {
    name: 'SearchFirms',
    components: { ViewFirmsTable, ErrorDialog, FirmsOptions, InformationDialogIcon, ListViewer, ViewFirm },
    data() {
      return {
        anIncreasingNumber: 1,
        checkedColumns: ['fid', 'sort', 'phone', 'state' ],
        clear: false,
        colHeaders: [], // for firms
        dense: true, // table density
        emptyFields: false,
        filter: null,
        firm: {},
        firmArray: [], // array of firms to view
        firms: [],
        newSearch: false,
        fullFieldData: [],
        groups: [],
        headers: [], // for jobs/notes
        id: 0,
        includeCheckColumns: {}, // columns that are specific to include boxes, but with "where"
        includeColumns: [], // columns that are specific to the include checkboxes
        info: [], // info from FirmsSearchOptions
        infoDialog: false,
        isSorting: false,
        isUnisearch: false,
        jobHeaders: [ // for jobs/notes
          {value: 'actions',  text: '',width: '70px', sortable: false, align: 'right', cellClass: 'px-0'},
          {value: 'data-table-select',          width: '5px'},
          {value: 'firm_sort',text: 'Firm Name',width: '235px'},
          {value: '_exdate',  text: 'Exdate',   width: '103px'},
          {value: 'status',   text: 'Status',   width: '110px'},
          {value: '_lag',     text: 'Age',      width: '90px'},
          {value: 'type',     text: 'Type',     width: '90px'},
          {value: 're',       text: 'Re',       width: '450px'},
          {value: 'cstamp',   text: 'Dated',    width: '210px'},
          {value: 'staff',    text: 'For',      width: '90px'},
          {value: 'closer',   text: 'Last',     width: '72px'},
          {value: 'opener',   text: 'By',       width: '68px'},
        ],
        jobs: [],
        jobsSelected: [],
        highlightedJobNid: 0,// 16 Jul 2026 JCH: NC-1616 — last job opened from this list (row wash)
        highlightedFirmFid: 0,// 16 Jul 2026 JCH: NC-1616 — last firm opened from firms list
        loading: false,
        loadingJob: false,
        nextJobNid: 0,
        nextJobFid: 0,
        names: '',
        nid: 0,
        noNote: true,
        noResults: false,
        noteData: undefined,
        notesOpen: false, //true if returning from email/note edit page
        notPopup: true,
        overFirmLimit: false,
        panels: [],
        refresh: false,
        refreshUsernames: false,
        refreshJobCount: false,
        savedSearch: false,
        savedSearchItems: {},
        search: '', // for jobs/notes
        searchByFid: false,
        searchItems: {},
        seeMoreOptions: false,
        seeMoreOptionsBelow: false,
        selectUsers: false,
        showCheckOptions: false,
        state: 'loadingJobs',
        switchToFirms: false,
        showedit: true,
        showFirm: true,
        showFirmTabs: false,
        sortBy: null,
        sortDesc: false,
        // floor so xs keeps a usable name (width/12-30 was ~1 char on phones → "la...")
        spaceForUsernames: Math.max(16, Math.floor(window.innerWidth / 12) - 20),
        statusForCheckedJobs: '',
        tab: null,
        totalPages: 0, // for pagination
        totalRecords: 0, // for pagination
        unisearch: '',
        user: '', // current user's username
        userId: 0,
        userJobCounts: [],//usernames with job counts
        userJobCountsLoading: false,// 16 Jul 2026 JCH: NC-1616 — dialog empty-state while counts load
        userJobCountsLoaded: false,// false until first fetch settles (avoids "no users" flash)
        userJobCountsFetchGen: 0,// ignore stale finally from overlapping fetches
        userSelectMenuMaxHeight: 200,// room below field; updated when dialog opens/resizes
        username: '',// username from login
        usernamesToShowJobsFor: '',// tracks which username(s) is for current jobs list
        jobsListMode: 'jobs',// 15 Jul 2026 JCH: NC-1616 — 'jobs' | 'ticklers' | 'retries'
        jobsToggleRefresh: 0,// 15 Jul 2026 JCH: NC-1616 — re-syncs the toggle after an ignored deselect (re-click)
        jobsFetchGeneration: 0,// 15 May 2026 JCH: bumped per fetch; stale resolutions ignored on mid-load toggle
        activeFirmSortTooltipNid: null,// 16 Jul 2026 JCH: only one firm-name tooltip; cleared on leave/search/scroll
        usernames: [],
        userPrefs: {},
        whereColumns: {},// columns that are specific to the where clause
      };
    },

    watch: {
      names() {
        if (this.names.length === 0) this.names = [this.username];// if usernames array is cleared out, set to current user
      },

      selectUsers(val) {
        if (!val) return;
        // dialog transition + layout — remeasure after paint (focus also remeasures when menu opens)
        this.$nextTick(() => {
          requestAnimationFrame(() => this.updateUserSelectMenuMaxHeight());
        });
      },

      seeMoreOptions() {
        if (this.seeMoreOptions) {
          this.state = 'showFirms';
          this.panels = [0];
        }
      },

      // 16 Jul 2026 JCH: close firm-name tooltip when the activator row may be replaced
      search() { this.activeFirmSortTooltipNid = null; },
      jobs() { this.activeFirmSortTooltipNid = null; },
      state(val) {
        this.activeFirmSortTooltipNid = null;
        if (val === 'showJobs' || val === 'loadingJobs') {
          this.$nextTick(() => this.bindJobsTableScrollClose());
        } else {
          this.unbindJobsTableScrollClose();
        }
      },
      anIncreasingNumber() {// table remounts on header drag — rebind scroll closer
        if (this.state === 'showJobs' || this.state === 'loadingJobs') {
          this.$nextTick(() => this.bindJobsTableScrollClose());
        }
      },
    },

    computed: {
      canBypassFirmListLimit() {
        return this.groups.includes('admin') || this.$_can('firm-list-override');// 29 Apr 2026 JCH: admin legacy override + targeted scope
      },

      jobsToggleValue() {// 16 Jul 2026 JCH: NC-1616 — segment stays lit through a firm opened from a jobs
        // list (Gmail-style drill-down: state stays showJobs, only panels empties; re-click restores the
        // list). Firms search results or a firm opened from them = state showFirms = nothing lit.
        return (this.state === 'showJobs' || this.state === 'loadingJobs') ? this.jobsListMode : null;
      },

      modeWords() {// 15 Jul 2026 JCH: NC-1616 — mode-aware copy for toolbar tips, dialogs & table text
        return this.jobsListMode === 'ticklers'
          ? { one: 'tickler', many: 'ticklers', Many: 'Ticklers' }
          : this.jobsListMode === 'retries'
            ? { one: 'retry', many: 'retries', Many: 'Retries' }
            : { one: 'job', many: 'jobs', Many: 'Jobs' };
      },

      userSelectMenuProps() {
        // open down; maxHeight = space under field so last rows stay on-screen
        return {
          offsetY: true,
          offsetOverflow: false,
          maxHeight: this.userSelectMenuMaxHeight,
        };
      },

      hasDetailedSearchFilters() {
        return Object.entries(this.whereColumns).some(([key, value]) => {
          if (key === 'fid') return false;
          return this.hasSearchValue(value);
        });
      },

      hiddenDetailedSearchFiltersActive() {
        return this.hasDetailedSearchFilters && !this.seeMoreOptions && !this.seeMoreOptionsBelow;
      },

      firmsHeaderCount() {
        if (!this.firms.length) return '';
        if (!this.isUnisearch && this.canBypassFirmListLimit && this.totalRecords) {
          return this.totalRecords.toLocaleString('en', { useGrouping: true });
        }
        return this.firms.length.toLocaleString('en', { useGrouping: true });
      },

      firmsNoResultsText() {// 16 May 2026 JCH: tailor empty-result snackbar to the search type the user just ran.
        if (this.searchByFid) {
          const fid = this.whereColumns && this.whereColumns.fid;
          return fid ? `No firm found for FID ${fid}.` : 'No firm found for that FID.';
        }
        if (this.isUnisearch) {
          const t = (this.unisearch || '').trim();
          return t ? `No firms match "${t}". Try a different term.` : 'No firms match. Try a different term.';
        }
        return 'No firms match those filters. Try broadening the search.';
      },

      firmsLoadingText() {// 15 May 2026 JCH: Distinguishes unisearch / FID lookup / detailed-search loads so spinner msg matches action.
        if (this.isUnisearch) {
          const t = (this.unisearch || '').trim();
          return `Loading unisearch firms${t ? ` for "${t}"` : ''}... Please wait`;
        }
        if (this.searchByFid) {
          const fid = this.whereColumns && this.whereColumns.fid;
          return `Loading firm by FID${fid ? ` ${fid}` : ''}... Please wait`;
        }
        if (this.hasDetailedSearchFilters) return 'Loading firms (filtered)... Please wait';
        return 'Loading firms... Please wait';
      },
    },

    created() {
      document.title = 'Firms';
      window.addEventListener("resize", this.handleResize);
    },

    destroyed() {
      window.removeEventListener("resize", this.handleResize);
      this.unbindJobsTableScrollClose();
    },

    mounted() {
      this.username = this.$store.getters.username;// get username of current user
      this.userId = this.$store.getters.userId;
      this.seeMoreOptions = this.$store.getters.seeMoreFirmsOptions;//flag to open firms search options
      this.$store.dispatch('SET_FIRMS_SEARCH_OPEN', false);
      this.groups = this.$store.getters.groups;
      this.$store.getters.userPreferences.jobHeaders ? this.headers
        = this.$store.getters.userPreferences.jobHeaders : this.headers = this.jobHeaders ;
      this.$store.getters.userPreferences.dense ? this.dense
        = this.$store.getters.userPreferences.dense : false;
      this.noteData = this.$store.getters.noteData;
      this.nextJobFid = this.noteData.nextJobFid ? this.noteData.nextJobFid : 0;
      this.nextJobNid = this.noteData.nextJobNid ? this.noteData.nextJobNid : 0;
      this.usernamesToShowJobsFor = [this.username];// initially get jobs for current user
      this.viewJobs(true, this.usernamesToShowJobsFor);
      if (this.$_can('job-override')) {// if scope, can view jobs of all users, else only user's own jobs withACLs
        // get list of usernames for dropdown
        usersAPIService.getUsernames(this.$router)
        .then((usernames) => {
          // 2 Feb 2026 JCH: guard against 401/handled errors returning undefined
          const rows = Array.isArray(usernames) ? usernames : [];
          this.usernames = rows.map(a => a.username).filter(Boolean);
          // 16 Jul 2026 JCH: NC-1616 — load counts after usernames (was racing with [])
          this.getJobsCountByUsers();
        })
        .catch((e) => {
          console.debug('❌ Failed to load usernames:', e);
          this.usernames = [];
          this.getJobsCountByUsers();// still try unfiltered counts for the dialog
        });
      }
    },

    directives: {//drag table column headers
      'sortable-table': {
        inserted: (el, binding) => {
          el.querySelectorAll('th').forEach((draggableEl) => {
            // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
            watchClass(draggableEl, 'sortHandle');
            draggableEl.classList.add('sortHandle');
          });
          Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value, handle: '.sortHandle' } : {});
        },
      },
    },

    methods: {
      callApi(searchItems, fromRefresh = false) {
        this.isUnisearch = false;
        if (!fromRefresh) this.firms = [];// 16 May 2026 JCH: new search clears stale rows; refresh keeps them visible
        firmAPIService.getFirm(searchItems, this.$router).then((data) => {
          const firms = Array.isArray(data['result']) ? data['result'] : [];
          if (firms.length >= 100 && !this.canBypassFirmListLimit) {
            this.overFirmLimit = true;
          }
          this.firms = firms;// 29 Apr 2026 JCH: this lets non-override users see capped rows instead of a blank table
          this.totalPages = data['totalpages'];
          this.totalRecords = data['count'];
          this.$store.dispatch('SET_NOTES_DATA', this.noteData);
          this.noteData = this.$store.getters.noteData;
          // 15 Jul 2026 JCH: NC-1616 — user may have clicked a Jobs/Retries/Ticklers segment while this
          // fetch was in flight; rows above stay cached for SEARCH FIRMS, but don't yank the view back
          if (this.state !== 'loadingFirms') return;
          if (this.totalRecords === 0) this.noResults = true;
          this.state = 'showFirms';
        }).catch((error) => {
          if (this.state !== 'loadingFirms') return;// 15 Jul 2026 JCH: NC-1616 — superseded by a list switch
          this.$refs.errorDialog.showError({
            errorMessage: 'Error getting firms',
            forDevelopers: error
          })
          this.state = 'showFirms';// end loading animation
        });
      },

      // clean column, even though you uncheck certain items, they still might be included
      // in the where clause even though the value is empty.
      // this method cleans that up before sending to the API
      cleanColumns() {
        Object.keys(this.whereColumns).forEach(key => {
          if (this.whereColumns.hasOwnProperty(key)) {
            const value = this.whereColumns[key];
            if (!value || value.length <= 0) {
              // get rid of it
              delete this.whereColumns[key];
            }
          }
        });
      },

      clearOptions() {
        this.$nextTick(() => {
          for (let key in this.whereColumns) {
            if (key !== 'fid') delete this.whereColumns[key];
          }
          this.checkedColumns = ['fid', 'sort', 'phone', 'state' ];
        });
      },

      firmPopup(id) {//passes fid, no note selected
        this.highlightedFirmFid = id;
        this.$_viewFirmNoNotePopup(id);
      },

      firmSearchInTab () {
        this.$store.dispatch('SET_FIRMS_SEARCH_OPEN', true);
        let baseUrl = window.location;
        window.open(baseUrl, '_blank');
      },

      getJobsCountByUsers() {// get the # of activejobs/extremejobs for each user to display in jobs dialog dropdown
        // 16 Jul 2026 JCH: NC-1616 — null = all users (API example); passing the usernames array made a bad query
        const gen = ++this.userJobCountsFetchGen;
        this.userJobCountsLoading = true;
        return note.getJobsCountByUsers(null, this.$router).then((userJobCounts) => {
          if (gen !== this.userJobCountsFetchGen) return;// superseded by a newer open/refresh
          const rows = Array.isArray(userJobCounts) ? userJobCounts.slice() : [];
          _.remove(rows, a => a.staff === this.username);// remove current username from dropdown
          this.userJobCounts = _.sortBy(rows, 'staff');// sort remaining usernames for dropdown
        }).catch((e) => {
          if (gen !== this.userJobCountsFetchGen) return;
          console.debug('❌ Failed to load job counts:', e);
          this.userJobCounts = [];
        }).finally(() => {
          if (gen !== this.userJobCountsFetchGen) return;
          this.userJobCountsLoading = false;
          this.userJobCountsLoaded = true;
        });
      },

      openSelectUsers() {// 16 Jul 2026 JCH: NC-1616 — refresh counts when opening so the menu isn't stuck empty
        // mark loading before the dialog paints so empty [] doesn't flash "No other users…"
        if (this.$_can('job-override')) this.userJobCountsLoading = true;
        this.selectUsers = true;
        if (this.$_can('job-override')) this.getJobsCountByUsers();
      },

      updateUserSelectMenuMaxHeight() {
        // min(space under field, xs 45vh / sm+ 65vh); floor 100. No fake geometry if field missing.
        const margin = 12;
        const minH = 100;
        const vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        const maxH = Math.floor(vh * (this.$vuetify.breakpoint.name === 'xs' ? 0.45 : 0.65));
        const dialog = document.querySelector('.jobs-users-dialog');
        const field = dialog && dialog.querySelector('.v-input');
        if (!field) {
          this.userSelectMenuMaxHeight = Math.min(200, maxH);
          return;
        }
        const available = vh - field.getBoundingClientRect().bottom - margin;
        this.userSelectMenuMaxHeight = Math.max(minH, Math.min(maxH, Math.floor(available)));
      },

      handleResize(e) {
        this.spaceForUsernames = Math.max(16, Math.floor(window.innerWidth / 12) - 20);
        if (this.selectUsers) this.updateUserSelectMenuMaxHeight();
      },

      // 16 Jul 2026 JCH: drive firm-name tooltip explicitly so a replaced activator can't leave it stuck
      firmSortTooltipOn(on, item) {
        const nid = item && item.nid;
        return {
          ...on,
          mouseenter: () => { this.activeFirmSortTooltipNid = nid; },
          focus: () => { this.activeFirmSortTooltipNid = nid; },
          mouseleave: () => {
            if (this.activeFirmSortTooltipNid === nid) this.activeFirmSortTooltipNid = null;
          },
          blur: () => {
            if (this.activeFirmSortTooltipNid === nid) this.activeFirmSortTooltipNid = null;
          },
        };
      },

      bindJobsTableScrollClose() {
        this.unbindJobsTableScrollClose();
        const wrap = this.$el && this.$el.querySelector('.jobsTable .v-data-table__wrapper');
        if (!wrap) return;
        this._jobsTableScrollEl = wrap;
        this._jobsTableScrollClose = () => { this.activeFirmSortTooltipNid = null; };
        wrap.addEventListener('scroll', this._jobsTableScrollClose, { passive: true });
      },

      unbindJobsTableScrollClose() {
        if (this._jobsTableScrollEl && this._jobsTableScrollClose) {
          this._jobsTableScrollEl.removeEventListener('scroll', this._jobsTableScrollClose);
        }
        this._jobsTableScrollEl = null;
        this._jobsTableScrollClose = null;
      },

      hasSearchValue(value) {
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === 'object') return Object.values(value).some(this.hasSearchValue);
        return value !== null && value !== undefined && value !== '';
      },

      jobsSelectedUpdate() {//mark status as statusForCheckedJobs, API doesn't get cancel/done, so no longer in job list
        let count = 1;//count how many jobs to update
        for (let j of this.jobsSelected) {
          j.status = this.statusForCheckedJobs;
          note.updateNote(j.nid, j, this.$router).then((response) => {
            if (this.jobsSelected.length === count) {// if last one then update jobs list, and de-select checkboxes
              // 16 Jul 2026 JCH: NC-1616 — must refetch (done/cancel drop rows). Passing the same
              // usernames array reference would hit viewJobs' fast path and skip the API.
              this.refresh = true;
              this.viewJobs(false, this.usernamesToShowJobsFor, this.jobsListMode);
            } else {
              count++;
            }
            }).catch((error) => {
            this.$refs.errorDialog.showError({
              errorMessage: 'Error changing job status',
              forDevelopers: error
            })
          });
        }
        this.showCheckOptions = false;
      },

      nextNote: function () {
        this.loadingJob = true;
        note.getNextNote(this.userId, this.$route)
          .then((response) => {
            if (response && response[0]) {
              this.nextJobFid = response[0].fid;
              this.nextJobNid = response[0].nid;
              this.noteData.status = 'Active';
              // use nid to update note with staff=username
              this.user = this.$store.getters.username;
              let parms = {staff: this.user};
              return note.updateNote(this.nextJobNid, parms, this.$router)
                .then((response) => {
                  this.loadingJob = false;
                  this.noNote = false;//tells view component that nid is being sent
                  this.viewFirm(this.nextJobNid, false);
                })
                .catch((error) => {
                  console.debug('error: ', error);
                });
            }
          })
          .catch((error) => {
            console.debug('error: ', error);
          });
      },

      jobRowClass(item) {// 16 Jul 2026 JCH: NC-1616 — wash the job row last opened from this list
        return item && item.nid === this.highlightedJobNid ? 'jobs-row-highlight' : '';
      },

      openJobFirmBelow(item) {
        this.seeMoreOptions = false;
        this.notPopup = true;
        this.highlightedJobNid = item.nid;// keep lit until another open or leave this list
        this.viewFirmJob(item.nid);
      },

      openJobFirmInPopup(item) {
        this.notPopup = false;
        this.highlightedJobNid = item.nid;
        this.viewFirmJob(item.nid);
      },

      refreshFirms() {
        this.highlightedFirmFid = 0;// left/refreshed firms list — drop row wash
        this.state = 'loadingFirms';
        this.isUnisearch ? this.unisearchFirms(true) : this.callApi(this.searchItems, true);
      },

      refreshJobs() {
        this.refresh = true;
        this.viewJobs(false, this.usernamesToShowJobsFor, this.jobsListMode);// 16 May 2026 JCH: keep current mode (jobs vs ticklers)
      },

      searchFirms() {
        this.newSearch = true;// this is a new search, not just a new page, so set page to 1 in setSearchItems()
        this.savedSearch = false;
        this.highlightedJobNid = 0;// left the jobs list
        this.highlightedFirmFid = 0;// new firms search — drop prior row wash
        this.state = 'showFirms';
        this.searchFirmsNow();
      },

      searchFirmsButton() {
        this.highlightedJobNid = 0;// left the jobs list
        this.state = 'showFirms';
        this.panels = [0];
      },

      searchFirmsNow() {
        const emptyButFid = Object.entries(this.whereColumns).every(([k, v]) => k === "fid" || v === null || v === '');
        if (emptyButFid && !this.searchByFid) {// if all fields are empty except fid and !searchByFid, alert emptyFields
          this.emptyFields = true;
          return;
        } // require narrowing of search to limit firms displayed
        this.seeMoreOptionsBelow = false;
        this.unisearch = '';
        this.panels = [0];
        this.state = 'loadingFirms';
        if (this.savedSearch === true) {
          this.savedSearch = false;
          this.callApi(this.savedSearchItems);
        } else {
          this.setSearchItems();
          this.callApi(this.searchItems);
        }
        this.cleanColumns();
      },

      setSearchItems() {
        // if not searching by fid, remove fid from search, else convert fid to integer so backend will accept
        !this.searchByFid ? delete this.whereColumns.fid : this.whereColumns.fid *=1;
        if (!this.checkedColumns.includes('fid')) this.checkedColumns.push('fid');// if unisearch removed fid, add back
        if (this.newSearch === true) this.$refs.viewFirmsTable.options.page = 1;// page=1 if newSearch, not page change
        const itemsPerPage = this.canBypassFirmListLimit
          ? this.$refs.viewFirmsTable.options.itemsPerPage
          : Math.min(this.$refs.viewFirmsTable.options.itemsPerPage, 100);
        this.searchItems = {
          page: this.$refs.viewFirmsTable.options.page,
          perPage: itemsPerPage,
          sortBy: this.$refs.viewFirmsTable.options.sortBy[0],
          sortDesc: this.$refs.viewFirmsTable.options.sortDesc[0],
          checkedColumns: this.checkedColumns,
          whereColumns: this.searchByFid ? {'fid': this.whereColumns.fid } : this.whereColumns,
          includeCheckColumns: this.includeCheckColumns,
          includeColumns: this.includeColumns,
          simple: false,
          getall: false,
        };
        this.newSearch = false;// reset newSearch so a page or other option change won't trigger resetting page to 1
      },

      sortTheHeadersAndUpdateTheKey(evt) {//drag job headers
        const headersTmp = this.headers;
        const oldIndex = evt.oldIndex;
        const newIndex = evt.newIndex;
        if (newIndex >= headersTmp.length) {
          let k = newIndex - headersTmp.length + 1;
          while (k--) {
            headersTmp.push(undefined);
          }
        }
        headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
        this.headers = headersTmp;
        this.anIncreasingNumber += 1;
        this.userPrefs.jobHeaders = this.headers;
        this.$store.dispatch('SET_USER_PREFERENCES', this.userPrefs);
      },

      unisearchFirms(fromRefresh = false) {
        this.isUnisearch = true;
        this.searchByFid = false;
        if (this.unisearch.length < 2) return;
        if (!fromRefresh) this.firms = [];// 16 May 2026 JCH: new search clears stale rows; refresh keeps them visible
        this.whereColumns.fid = '';
        this.state = 'loadingFirms';
        this.checkedColumns = [ 'state', 'phone', 'contact', 'sort', 'insured', 'name1', 'name2' ];
        let params = {
          search: this.unisearch
        };
        this.seeMoreOptions = false;
        this.seeMoreOptionsBelow = false;
        this.panels = [0];
        firmAPIService.getUnisearchFirm(params, this.$router).then((data) => {
          if (data.length >= 100) this.overFirmLimit = true;
          this.firms = data;
          this.totalRecords = this.firms.length;
          // 15 Jul 2026 JCH: NC-1616 — same race guard as callApi: a segment click mid-fetch wins
          if (this.state !== 'loadingFirms') return;
          if (data.length === 0) this.noResults = true;
          this.state = 'showFirms';
        }).catch((error) => {
          if (this.state !== 'loadingFirms') return;// 15 Jul 2026 JCH: NC-1616 — superseded by a list switch
          this.$refs.errorDialog.showError({
            errorMessage: 'An error occurred while trying to unisearch the firms. ' +
              'Please ensure the form is filled out completely and correctly. ' +
              'If the problem persists please notify the development team with a detailed ' +
              'description of the error.',
            forDevelopers: error
          })
          this.state = 'showFirms';// end loading animation
        });
      },

      update(info) {// from FirmOptions.vue
        this.checkedColumns     = info[0];
        this.whereColumns       = info[1];
      },

      viewFirm(id) {//get firm and add to firmArray
        //props/params for FirmsSearch, ViewFirm, FirmNotesTable, EditNoteEmail
        this.noteData.savedSearchItems = this.searchItems;//saved and used in firmsSearch,
        this.noteData.state = this.state; //saved in firmsSearch, used in firm notes table
        this.noteData.nextJobNid = this.nextJobNid; //saved in firmsSearch, used in firm notes table
        this.noteData.nextJobFid = this.nextJobFid; //saved in firmsSearch, used in firm notes table
        this.$store.dispatch('SET_NOTES_DATA', this.noteData);
        if (!this.notPopup) {
          this.$_viewFirmNotePopup(id);
        } else {
          this.id = id;// set id for view component - if not going to popup
          this.showFirm = !this.showFirm;// if firm was just closed & opened, trigger ViewFirm watch
          this.panels = [];
          this.showFirmTabs = true;
        }
      },

      viewFirmJob(nid) {//pass job.nid to get note and firm and nextJobFid
        this.noteData.status = 'Active';
        this.noNote = false;//tells view component that nid is being sent
        this.viewFirm(nid);
      },

      viewFirmSearch(fid) {//pass fid to get firm
        this.highlightedFirmFid = fid;// wash this firms-list row until another open or leave firms
        this.noteData.status = 'All';
        this.noNote = true;//tells view component that fid is being sent
        this.viewFirm(fid);
      },

      onJobsRetriesToggle(mode) {// 15 Jul 2026 JCH: NC-1616 — sticky-bar segment click: switch lists, or return
        // to the current list (re-click, from firms mode, or from an open firm — viewJobs restores panels).
        // Vuetify emits undefined when the active segment is re-clicked (deselect); treat that as the current
        // mode and bump the key so the group re-syncs to jobsToggleValue, which hasn't changed.
        const next = mode || this.jobsListMode;
        this.jobsToggleRefresh += 1;
        this.seeMoreOptions = false;
        this.seeMoreOptionsBelow = false;
        this.viewJobs(false, this.usernamesToShowJobsFor || [this.username], next);
        // 16 Jul 2026 JCH: NC-1616 — list can already be open above a firm; re-click/mode switch must
        // still bring the viewport back to the jobs table (fast path leaves layout unchanged).
        this.$nextTick(() => window.scrollTo(0, 0));
      },

      viewJobs(initial, usernames, mode = 'jobs') {// 15 Jul 2026 JCH: NC-1616 mode='retries' uses job=retries; ticklers = MY ticklers
        const username = [this.username];
        this.panels = [0];
        this.highlightedFirmFid = 0;// left firms list
        // if not initial call and not refresh and sameUsername (and already on same list), just update state to display, but don't call API
        if ((mode === 'jobs' || mode === 'retries') && !initial && !this.refresh && usernames === this.usernamesToShowJobsFor
            && this.jobsListMode === mode && this.state !== 'loadingJobs') {
          this.state = 'showJobs';
          this.selectUsers = false;
          return;// keep highlightedJobNid — returning to the same list
        }
        // mode switch / refresh / user change — leave this list, drop the row wash
        this.highlightedJobNid = 0;
        const gen = (this.jobsFetchGeneration += 1);// 15 May 2026 JCH: supersede in-flight fetch on mid-load toggle
        if (this.jobsListMode !== mode) this.jobs = [];// 15 May 2026 JCH: drop stale rows when switching modes
        this.jobsListMode = mode;// 15 May 2026 JCH: flip early so loading text/toggle/labels match this fetch
        this.state = 'loadingJobs';
        this.jobsSelected = [];
        const withACLs = mode === 'jobs' && _.isEqual(usernames, username);// 16 May 2026 JCH: withACLs only when fetching current user's own jobs
        const fetch = mode === 'ticklers'
          ? note.getTicklersJobs(this.username, this.$router)
          : mode === 'retries'
            ? note.getRetriesJobs(usernames, this.$router)// 15 Jul 2026 JCH: NC-1616 — job=retries (not job=users&type=retry)
            : note.getJobs({ usernames, job: 'users', withACLs }, this.$router);
        return fetch.then((jobs) => {
          if (gen !== this.jobsFetchGeneration) return;// 15 May 2026 JCH: superseded by a newer toggle click
          // 20 Mar 2026 JCH: Avoid runtime crash when auth/redirect flows return a non-array payload.
          const rows = Array.isArray(jobs) ? jobs : [];
          this.usernamesToShowJobsFor = mode === 'ticklers' ? [this.username] : usernames;
          this.jobs = rows;
          // can't change a row that isn't theirs (Vuetify disables when selectable === false).
          // 16 Jul 2026 JCH: NC-1616 — retries sometimes omit staff; list is already scoped by usernames,
          // so allow those when viewing only yourself. Also trim so "jeannette " doesn't disable the box.
          const me = String(this.username || '').trim();
          const onlyMe = Array.isArray(usernames)
            ? usernames.length === 1 && String(usernames[0] || '').trim() === me
            : String(usernames || '').trim() === me;
          for (const j of rows) {
            const staff = j.staff == null ? '' : String(j.staff).trim();
            if (staff) j.selectable = staff === me;
            else if ((mode === 'retries' || mode === 'ticklers') && onlyMe) j.selectable = true;
            else j.selectable = false;
          }
          this.refresh = false;
          this.jobsListMode = mode;
          this.state = 'showJobs';
          this.refreshUsernames = !this.refreshUsernames;// refresh to show new list of which usernames' jobs show
          this.selectUsers = false;
        }).catch((error) => {
          if (gen !== this.jobsFetchGeneration) return;
          if (mode !== 'ticklers' && mode !== 'retries') return;// 15 Jul 2026 JCH: surface errors for ticklers + retries
          this.$refs.errorDialog.showError({
            errorMessage: mode === 'retries' ? 'Error loading retry jobs' : 'Error loading tickler jobs',
            forDevelopers: error
          });
          this.state = 'showJobs';
          this.jobs = [];
        });
      },

    },
  };
</script>

<style>
  .smalltext.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    font-size: 14px !important;
  }
  .custom.v-text-field>.v-input__control>.v-input__slot:before {
    margin-top: 10px;
    font-size: 0.875rem;
    font-weight: 600;
    color: black !important;
    font-family: Roboto, 'Avenir', Helvetica, Arial, sans-serif;
    border-style: none;
  }
  .custom.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none;
  }
  .theme--light.v-data-table thead tr:last-child th {
    z-index: 2 !important;
  }
  .noPadding .v-expansion-panel-content__wrap {
    padding: 0;
  }
  .v-data-table--fixed-header > .v-data-table__wrapper {
    overflow-y: auto;
    padding-bottom: 6px;/* adds space at bottom of tables so row can be seen above scrollbar */
  }
  .v-data-table {line-height: 1.2 !important;}
  .firms-title-group {align-items: center; display: inline-flex; min-width: 120px;}
  .firms-title-text {font-size: 1rem; line-height: 1.1;}
  /* 16 Jul 2026 JCH: NC-1616 — align firms header chrome with Unisearch row */
  .firms-title-group .firms-refresh-btn { transform: translateY(2px); }
  .firm-unisearch-field .v-input__prepend-outer { transform: translateY(-1px); }
  /* desktop: one more px each — still a hair off after the first nudge */
  @media (min-width: 601px) {
    .firms-title-group .firms-refresh-btn { transform: translateY(3px); }
    .firm-unisearch-field .v-input__prepend-outer { transform: translateY(-2px); }
  }
  /* 15 Jul 2026 JCH: NC-1616 — Jobs/Retries/Ticklers segments in the sticky bar (same pattern as the
     email page Show toggle); selected = filled secondary darken-2. Segments are 28px (small) like the
     View Jobs button they replaced, so the hardcoded table-height offsets (jobsTable 75px) still hold. */
  /* 26px (vs the bar's 28px controls) so the trio doesn't touch the bar's bottom edge */
  .jobs-retries-toggle .v-btn.v-btn { text-transform: none; height: 26px !important; }
  /* border lifted from Vuetify's 12% black so the eye can find the control on the white bar;
     selector must out-rank the theme's !important border rule */
  .jobs-retries-toggle.theme--light.v-btn-toggle:not(.v-btn-toggle--group) > .v-btn.v-btn {
    border-color: rgba(0, 0, 0, 0.3) !important;
  }
  /* label typography mirrors the small text buttons (SEARCH FIRMS) but stays grey = not clickable */
  .jobs-toggle-view-label { font-size: 0.75rem; font-weight: 500; letter-spacing: .0893em; text-transform: uppercase; }
  .jobs-retries-toggle .v-btn.v-btn--active {
    background-color: var(--v-secondary-darken2) !important;
    color: #fff !important;
  }
  .jobs-retries-toggle .v-btn.v-btn--active .v-btn__content { color: #fff !important; font-weight: 700; }
  .jobs-retries-usernames { cursor: pointer; }
  /* reserved width so the username doesn't jump sideways when the count arrives/changes */
  .jobs-count { display: inline-block; min-width: 40px; text-align: right; }
  /* 16 Jul 2026 JCH: NC-1616 — users dialog header; xs: smaller type + more gap between title & buttons */
  .jobs-users-dialog-title { flex: 1 1 auto; min-width: 0; line-height: 1.3; }
  .jobs-users-dialog-actions { flex-wrap: nowrap; align-items: center; }
  @media (max-width: 600px) {
    /* pt-4 is 16px — pull the title/Show/Close row up ~4px */
    .jobs-users-dialog .jobs-users-dialog-actions {
      padding-top: 12px !important;
      padding-left: 12px !important;
      gap: 10px;
    }
    .jobs-users-dialog .jobs-users-dialog-title {
      font-size: 0.8rem;
      line-height: 1.25;
      padding-right: 4px;
    }
    .jobs-users-dialog .jobs-users-dialog-show {
      min-width: 0 !important;
      padding: 0 8px !important;
      font-size: 0.7rem !important;
      letter-spacing: 0.02em;
      flex-shrink: 0;
    }
    .jobs-users-dialog .jobs-users-dialog-close {
      margin-left: 0 !important;
      transform: scale(0.85);
      flex-shrink: 0;
    }
  }
  /* 16 Jul 2026 JCH: NC-1616 — last-opened job/firm row (not checkbox-selected grey) */
  .jobsTable tr.jobs-row-highlight { background: rgba(76, 95, 60, 0.12) !important; }
  .firmsJobsTable tr.firms-row-highlight { background: rgba(76, 95, 60, 0.12) !important; }
  .firm-fid-wrap { width: calc(60px + 20vw); }
  /* desktop: Get by FID nearer underline (Vuetify dense default top is 4px) */
  @media (min-width: 601px) {
    .firm-fid-wrap .v-label:not(.v-label--active) {
      top: 6px !important;
    }
    /* dense default top is 4px; +1px closer to underline */
    .jobs-search-wrap .v-label:not(.v-label--active) {
      top: 5px !important;
    }
  }
  /* desktop: even distribution + 2px sides; xs: space-between + 4px sides (see media query) */
  .firms-sticky-bar { justify-content: space-around; padding: 0 2px; }
  /* 16 Jul 2026 JCH: NC-1616 — dense unisearch + mt-n12 sat too high in the 58px #plain bar.
     Must beat .v-application .mt-n12 (-48px !important, 0,2,0). Applies ALL widths (not xs-only). */
  .v-application .firm-unisearch-field.mt-n12 {
    margin-top: -28px !important;
  }
  /* 15 Jul 2026 JCH: NC-1616 — Vuetify expansion headers default to 64px, which busts the jobsTable
     75px height budget (prod's clipped bottom row). 58px is the computed max that keeps the table
     bottom flush inside the viewport (57 + H + 777 + mb-2 = 100vh exactly at 58) while staying close
     to the airier 64px look; the cluster nudges below align the count/usernames with the icons' line */
  #plain { min-height: 58px; }
  .jobs-toolbar-up5 { transform: translateY(-5px); }
  .jobs-toolbar-cluster { transform: translateY(-6px); }
  @media (max-width: 600px) {
    .firms-search-info-title + .v-card__text {line-height: 1.05;}
    /* 16 Jul 2026 JCH: NC-1616 — jobs info dialog body smaller on phone
       (no ::v-deep: unscoped style — deep was dropped from the CSSOM). Also hit <p>
       so Vuetify body text doesn't keep 14px on children. */
    .v-application .v-dialog .jobs-info-dialog-title + .v-card__text,
    .v-application .v-dialog .jobs-info-dialog-title + .v-card__text p {
      font-size: 12px !important;
      line-height: 1.25 !important;
    }
    /* xs: wider unisearch + smaller chrome so typed text has room */
    .firm-unisearch-field {
      margin-right: 4px !important;
      padding-right: 0 !important;
      width: 65vw !important;
    }
    .firm-unisearch-field input {
      font-size: 0.8rem !important;
    }
    .firm-unisearch-field .v-label {
      font-size: 0.75rem !important;
    }
    .firm-unisearch-field .v-input__prepend-outer,
    .firm-unisearch-field .v-input__prepend-inner,
    .firm-unisearch-field .v-input__append-inner {
      transform-origin: center center;
    }
    /* combine scale with 1px nudges — scale alone would wipe translateY from the base rule */
    .firm-unisearch-field .v-input__prepend-outer {
      margin-right: -4px !important;
      transform: scale(0.8) translateY(-1px); /* (i) 1px up */
    }
    .firm-unisearch-field .v-input__prepend-inner {
      margin-right: -2px !important;
      transform: scale(0.8);
    }
    .firm-unisearch-field .v-input__append-inner {
      transform: scale(0.8) translateY(1px); /* magnify was 1px high */
    }
    .firms-title-group {min-width: 140px;}
    .firms-title-text {font-size: 0.85rem; line-height: 1;}
    /* 16 Jul 2026 JCH: NC-1616 — shrink sticky bar controls so the trio + FID + Firms fit one row */
    .firms-sticky-bar {
      justify-content: space-between !important;
      align-items: center;
      padding: 0 4px !important;
      gap: 4px;
    }
    .firms-sticky-toggle { min-width: 0; }
    .jobs-retries-toggle .v-btn.v-btn {
      padding: 0 3px;
      min-width: 0;
      height: 22px !important;
    }
    .jobs-retries-toggle .v-btn__content {
      font-size: 0.65rem;
      letter-spacing: 0;
      font-weight: 500;
    }
    .firm-fid-wrap {
      flex: 1 1 auto;
      width: auto !important;
      min-width: 72px;
      max-width: 34%;
      margin-top: -2px !important;
      margin-bottom: 0 !important;
    }
    .firm-fid-wrap .smalltext.px-3 { padding-left: 4px !important; padding-right: 4px !important; }
    /* pull placeholder down onto the underline (label was sitting high in a tall slot) */
    .firm-fid-wrap .v-text-field--dense > .v-input__control > .v-input__slot {
      min-height: 20px !important;
      margin-bottom: 0 !important;
    }
    .firm-fid-wrap .v-text-field input {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      margin-top: 0 !important;
    }
    .firm-fid-wrap .v-label {
      font-size: 0.75rem !important;
      line-height: 1 !important;
      height: 12px !important;
      top: 6px !important; /* sit just above the underline */
    }
    .firms-sticky-actions { gap: 0; }
    .firms-sticky-fab { margin-left: 2px !important; margin-right: 2px !important; }
    .firms-sticky-fab.v-btn--fab { transform: scale(0.65) !important; margin-top: 0 !important; }
    .firms-sticky-firms.v-btn {
      min-width: 0 !important;
      padding: 0 2px !important;
      font-size: 0.7rem !important;
      letter-spacing: 0 !important;
    }
    /* username after the count — a bit more room than 72px; still leaves the short search */
    .jobs-usernames-wrap {
      max-width: 110px;
      overflow: hidden;
      white-space: nowrap;
      font-size: 0.75rem;
    }
    .jobs-count { min-width: 28px; }
    .jobs-usernames-wrap .jobs-retries-usernames,
    .jobs-usernames-wrap .ticklers-own-user,
    .jobs-usernames-wrap .jobs-nonoverride-user {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* xs-only short search (class only rendered when breakpoint === xs) */
    .jobs-search-wrap-xs {
      position: relative;
      width: 48px !important;
      max-width: 48px !important;
      min-width: 0 !important;
      flex: 0 0 48px;
      align-self: center;
      margin-top: -8px; /* 16 Jul 2026 JCH: NC-1616 — whole field 2px higher */
      margin-left: 4px;
      margin-right: 2px;
      overflow: visible;
    }
    .jobs-search-wrap-xs .jobs-search-field-xs,
    .jobs-search-wrap-xs .v-input,
    .jobs-search-wrap-xs .v-input__control {
      width: 48px !important;
      max-width: 48px !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      flex: none !important;
      height: auto !important;
      min-height: 0 !important;
    }
    .jobs-search-wrap-xs .v-input__slot {
      position: relative;
      min-height: 20px !important;
      margin-bottom: 0 !important;
      min-width: 0 !important;
    }
    .jobs-search-wrap-xs input {
      padding: 0 !important;
      font-size: 0.75rem !important;
      min-width: 0 !important;
    }
    /* absolute magnify so hiding it on type doesn't reflow the slot (was jumping up) */
    .jobs-search-wrap-xs .v-input__append-inner {
      position: absolute !important;
      right: 0;
      top: auto !important; /* beat Vuetify's top:-4px on append */
      bottom: 4px; /* 16 Jul 2026 JCH: NC-1616 — nudge magnify up 2px */
      height: 12px !important;
      margin: 0 !important;
      padding: 0 !important;
      align-self: auto;
      pointer-events: none; /* decorative — don't steal clicks from the input */
    }
    .jobs-search-wrap-xs .v-input__icon {
      height: 12px !important;
      min-width: 12px !important;
      width: 12px !important;
    }
    .jobs-search-wrap-xs .v-input__append-inner .v-icon {
      font-size: 12px !important;
      height: 12px !important;
      width: 12px !important;
    }
    /* placeholder=" " enables :placeholder-shown — hide once typed */
    .jobs-search-wrap-xs:has(input:not(:placeholder-shown)) .v-input__append-inner {
      visibility: hidden !important;
    }
    .jobs-search-caption {
      display: block;
      margin-top: 1px;
      font-size: 0.65rem;
      line-height: 1;
      letter-spacing: 0.02em;
      color: rgba(0, 0, 0, 0.54);
      text-align: left;
      pointer-events: none;
      user-select: none;
    }
  }
  .fullSizeTable .v-data-table__wrapper{height:calc(100vh - 228px) !important;}
  .firmsJobsTable .v-data-table__wrapper{height:calc(100vh - var(--offset) - 120px) !important;}
  .firmsJobsTableNoFooter .v-data-table__wrapper{height:calc(100vh - var(--offset) - 75px) !important;}
  .jobsTable .v-data-table__wrapper{height:calc(100vh - var(--offset) - 75px) !important;}
  .largeSizeTable .v-data-table__wrapper{height:calc(100vh - var(--offset) - 206px) !important;}
  .largeSizeTableNoFooter .v-data-table__wrapper{height:calc(100vh - var(--offset) - 160px) !important;}
  .largeSizePoliciesTableNoFooter .v-data-table__wrapper{height:calc(100vh - var(--offset) - 267px) !important;}
  .popupLargePoliciesTableNoFooter .v-data-table__wrapper{height:calc(100vh - var(--offset) - 195px) !important;}
  .popupLargeTable .v-data-table__wrapper{height:calc(100vh - var(--offset) - 142px) !important;}
  .popupLargeTableNoFooter .v-data-table__wrapper{height:calc(100vh - var(--offset) - 96px) !important;}
  .v-toolbar__content, .v-toolbar__extension {
    padding: 0;
  }
  theme--light.v-select .v-select__selection--comma {
    padding-bottom: 10px;
  }
  #plain .v-btn::before{
    background-color: transparent;
  }
</style>
